import React, { Component } from "react";

import PropTypes from 'prop-types';
import './FinancialsBanner.scss';

class FinancialsBanner extends Component {

  render() {
    return (
      <div key="banner" className={this.props.extraclass} style={this.props.bannerStyle && this.props.bannerStyle}>
        {this.props.image &&
          <img
            src={this.props.image}
            className={this.props.imageClass && this.props.imageClass}
          />
        }
        <div>{this.props.title}</div>
      </div>
    );
  }

}

FinancialsBanner.propTypes = {
  title: PropTypes.string.isRequired,
  bannerStyle: PropTypes.object,
  image: PropTypes.string,
  imageClass: PropTypes.string,
};

export default FinancialsBanner;